import React from "react";
import { AccessibilityClickableDiv } from "@skillz/accessibility";
import classes from "./DiscoveryMobileFilterOption.module.css";

const DiscoveryMobileFilterOption = ({ option, lang, isSelected, onClick }) => {
    return (
        <AccessibilityClickableDiv className={`${classes.OptionChip} ${isSelected ? classes.OptionChipSelected : ""}`} onClick={onClick} role="option">
            {option?.label?.[lang]}
        </AccessibilityClickableDiv>
    );
};

export default DiscoveryMobileFilterOption;
